import type { MediaUrlDto } from '@bldsoft/cappie/api/wbs'
import type { LaData, MediaUrl } from '@setplex/tria-api'

type MediaUrlDtoWithHeaders = MediaUrlDto & {
  headers?: Record<string, string>
}

export const formatMediaUrl = (media: MediaUrlDto): MediaUrl => ({
  playbackUrl: media.playbackUrl!,
  headers: (media as MediaUrlDtoWithHeaders).headers,
  drm: media.drm as
    | {
        la: Record<string, LaData>
      }
    | undefined,
  stoppedTime: media.stoppedTime!,
})
